import 'src/polyfills';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxStoreProvider } from 'react-redux';
import { KatSpinner } from '@amzn/katal-react';
import { handleRefParameterConversion } from 'src/utils/refParameterConversion';
import { enableBrowserMocks } from 'mocks';
import { HelmetProvider } from 'react-helmet-async';

import './index.css';
import ReactRouterProvider from './components/react-router/ReactRouterProvider';
import store from './redux/store';
import { initializeStore } from './redux/initialization';

initializeStore(store);

// Handle ref parameter conversion before initializing the app
handleRefParameterConversion();

enableBrowserMocks().then(() => {
  createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <React.Suspense fallback={<KatSpinner size="large" />}>
        <HelmetProvider>
          <ReduxStoreProvider store={store}>
            <ReactRouterProvider />
          </ReduxStoreProvider>
        </HelmetProvider>
      </React.Suspense>
    </React.StrictMode>,
  );
});
